import React from "react";
import { Navigate } from "react-router-dom";
import { isAuthenticated } from "utils/helpers/CommonHelper";

interface AuthWrapperProps {
  children: React.ReactNode;
}

const AuthWrapper: React.FC<AuthWrapperProps> = ({ children }) => {
  if (!isAuthenticated()) {
    // Redirect to login page if the user is not authenticated
    return <Navigate to="/login" />;
  }
  return <>{children}</>;
};

export default AuthWrapper;
